import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class FacePressuresForcesDataModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (FacePressuresForcesDataModel._instance == null) FacePressuresForcesDataModel._instance = new FacePressuresForcesDataModel(authManager);
        return FacePressuresForcesDataModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'face-pressures/face-pressures-forces-data');

        this.entityName = 'face-pressures.FacePressuresForcesData';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'J S Eremax Result';
        this.setLabel = 'J S Eremax Results';

        this.browser = {
            name: 'default-face-pressures-facepressuresforcesdata-browser',
            moduleName: 'default-face-pressures-facepressuresforcesdata-browser',
            moduleTitle: 'J S Eremax Results',
            moduleStateSlotName: 'default-face-pressures-facepressuresforcesdata-browser',
        };

        this.editor = {
            name: 'default-face-pressures-facepressuresforcesdata-editor',
            moduleName: 'default-face-pressures-facepressuresforcesdata-editor',
            moduleTitle: 'J S Eremax Result',
            moduleStateSlotName: 'default-face-pressures-facepressuresforcesdata-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'uid',
                type: 'string',
                persistent: true,
                label: 'Unique ID',
                required: true,
                readOnly: true,
            },
            {
                name: 'calculationId',
                type: 'FacePressuresCalculation',
                persistent: true,
                label: 'Calculation',
            },
            {
                name: 'wedgeSlidingAngleZeta',
                type: 'float',
                persistent: true,
                unit: 'deg',
                label: 'Wedge Sliding Angle Zeta',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'slidingWedgeWeightG',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Sliding Wedge Weight G',
                description: 'G',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'rectangularAreaRequiredSupportEarthForceEre',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Rectangular Area Required Support Earth Force Ere',
                description: 'Ere',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalLoadFromSolidPrismPv',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Load From Solid Prism Pv',
                description: 'Pv',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalSlipSurfaceShearForceFromCohesionTc',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Slip Surface Shear Force From Cohesion Tc',
                description: 'Tc',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalSlipSurfaceShearForceFromFrictionTr',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Slip Surface Shear Force From Friction Tr',
                description: 'Tr',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'verticalSlipSurfaceShearForceFromFrictionCohesionT',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Vertical Slip Surface Shear Force From Friction Cohesion T',
                description: 'T',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'rectangularAreaRequiredSupportWaterForceWre',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Rectangular Area Required Support Water Force Wre',
                description: 'Wre0',
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'tunnelFaceRequiredSupportWaterForceWci',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Tunnel Face Required Support Water Force Wci',
                description: 'Wre1',
            },
            {
                name: 'tunnelFaceRequiredSupportEarthForceEmaxci',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Tunnel Face Required Support Earth Force Emaxci',
                description: 'Ere1Critical',
            },
            {
                name: 'requiredMinimumSupportForceAtTunnelAxisFaxis1',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Required Minimum Support Force At Tunnel Axis Faxis 1',
            },
            {
                name: 'tunnelFaceRequiredSupportWaterForceInclSafetyCoefWcis',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Tunnel Face Required Support Water Force Incl Safety Coef Wcis',
                description: 'Wre2',
            },
            {
                name: 'tunnelFaceRequiredSupportEarthForceInclSafetyCoefEmaxcis',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Tunnel Face Required Support Earth Force Incl Safety Coef Emaxcis',
                description: 'Ere2Critical',
            },
            {
                name: 'requiredMinimumSupportForceAtTunnelAxisInclSafetyCoefFaxis2S',
                type: 'float',
                persistent: true,
                unit: 'kN',
                label: 'Required Minimum Support Force At Tunnel Axis Incl Safety Coef Faxis 2 S',
            },
        ];

    }

}
